module.exports = __webpack_public_path__ + "img/clock.ad6d268d.svg";